import { memo } from 'react';
import IframeResizer from 'iframe-resizer-react';

import { NOTIFICATION_SETTINGS_MFE } from './microfrontendsConfig';

export const NotificationSettingsMfe = memo(() => {
    return <IframeResizer src={NOTIFICATION_SETTINGS_MFE.url} checkOrigin={false} style={{ width: '1px', minWidth: '100%', border: '0', minHeight: '200px' }} />;
});
